import api from './api';

export const progressService = {
  // Get all progress
  getAllProgress: async () => {
    const response = await api.get('/progress');
    return response.data;
  },
  
  // Get learning stats
  getStats: async () => {
    const response = await api.get('/progress/stats');
    return response.data;
  },
  
  // Update lesson progress
  updateLessonProgress: async (lessonId, courseId, status = 'completed') => {
    const response = await api.post(`/progress/lesson/${lessonId}`, {
      courseId,
      status,
    });
    return response.data;
  },
  
  // Get course progress
  getCourseProgress: async (courseId) => {
    const response = await api.get(`/progress/course/${courseId}`);
    return response.data;
  },
  
  // Get streak
  getStreak: async () => {
    const response = await api.get('/progress/streaks');
    return response.data;
  },
};

export default progressService;




